export default {"src":"/_next/static/media/funeral.c2270337.svg","height":66,"width":65,"blurWidth":0,"blurHeight":0};